var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4683 25L9.74211 24.3776C8.74104 23.5393 0 15.9902 0 10.4683C0 4.68682 4.68682 0 10.4683 0C16.2497 0 20.9366 4.68682 20.9366 10.4683C20.9366 15.9903 12.1955 23.5394 11.1986 24.3817L10.4683 25ZM10.4683 2.26355C5.93908 2.26867 2.26872 5.93903 2.2636 10.4682C2.2636 13.9373 7.64142 19.479 10.4683 22.0154C13.2952 19.4779 18.673 13.9331 18.673 10.4682C18.6678 5.93903 14.9975 2.26872 10.4683 2.26355Z",
    fill: "#0464B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4679 14.6178C8.17617 14.6178 6.31836 12.76 6.31836 10.4683C6.31836 8.17654 8.17617 6.31873 10.4679 6.31873C12.7596 6.31873 14.6174 8.17654 14.6174 10.4683C14.6174 12.76 12.7597 14.6178 10.4679 14.6178ZM10.4679 8.39344C9.32203 8.39344 8.39313 9.32235 8.39313 10.4682C8.39313 11.6141 9.32203 12.543 10.4679 12.543C11.6138 12.543 12.5427 11.6141 12.5427 10.4682C12.5427 9.32235 11.6138 8.39344 10.4679 8.39344Z",
    fill: "#0464B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationBlue);
export default __webpack_public_path__ + "static/media/locationBlue.50488765a7fd32e202dcd5137a66e5c4.svg";
export { ForwardRef as ReactComponent };